import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Crop } from '../../shared/services/crop.service';
import { ContainerDefinition } from '../../shared/services/container-definition.service';
import { Substrate } from '../../shared/services/substrate.service';
import { ReportingService } from '../services/reporting.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { ReportingFilterOptions, REPORTING_FILTER_OPTIONS } from '../services/reporting-filter-options.service';
import { AlphabeticalNamedSorter } from '../../shared/sort-methods';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';
import { TransplantReportFormGroup } from './transplant-report-form-group';

@Component({
  selector: 'app-transplant-report-form',
  templateUrl: './transplant-report-form.component.html'
})
export class TransplantReportFormComponent implements OnInit {
  public rootForm: TransplantReportFormGroup;

  public get startDateFormControl(): FormControl {
    return this.rootForm.startDateFormControl;
  }
  
  public get endDateFormControl(): FormControl {
    return this.rootForm.endDateFormControl;
  }

  public get cropFormControl(): FormControl {
    return this.rootForm.cropFormControl;
  }

  public get containerTypeFormControl(): FormControl {
    return this.rootForm.containerTypeFormControl;
  }

  public get substrateFormControl(): FormControl {
    return this.rootForm.substrateFormControl;
  }

  public crops: Crop[];
  public potTypes: ContainerDefinition[];
  public substrates: Substrate[];

  constructor(@Inject(REPORTING_FILTER_OPTIONS) options: ReportingFilterOptions, 
    private loadingService: LoadingWrapperService, 
    private alertService: AlertService,
    private reportingService: ReportingService,
    private reportWriterService: FileSaverService) { 
    this.rootForm = new TransplantReportFormGroup();
    options.crops.subscribe(c => this.crops = c.sort(AlphabeticalNamedSorter));
    options.potTypes.subscribe(f => this.potTypes = f.sort(AlphabeticalNamedSorter));
    options.substrates.subscribe(s => this.substrates = s.sort(AlphabeticalNamedSorter));
  }

  ngOnInit() {
  }

  public generateReport(): void {
    this.loadingService.setMessage('Generating transplant report...');

    this.reportingService.getTransplantReport({ 
      containerTypeId: this.containerTypeFormControl.value,
      cropId: this.cropFormControl.value,
      endDate: this.endDateFormControl.value,
      startDate: this.startDateFormControl.value,
      substrateId: this.substrateFormControl.value
    })      
    .pipe(finalize(() => this.loadingService.clearMessage()))
    .subscribe(
      file => this.reportWriterService.save(file), 
      error => this.alertService.error('Error generating transplant report.'));
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/transplant-report-form/transplant-report-form.component.ts